import React from 'react'
import PropTypes from 'prop-types'
import {Eye, EyeOff} from '../Icons/index.jsx'
import Input from './Input.jsx'

export default class InputPassword extends React.Component {
  static defaultProps = {
    onChange: Function.prototype,
    onFocus: Function.prototype,
  }
  static propTypes = {
    className: PropTypes.string,
    label: PropTypes.string,
    placeholder: PropTypes.string,
    value: PropTypes.any,
    onChange: PropTypes.func,
    onFocus: PropTypes.func,
    onBlurInput: PropTypes.func,
    isValid: PropTypes.bool,
    showValidation: PropTypes.bool,
    isMandatory: PropTypes.bool,
    labelHelp: PropTypes.string,
    invalidMessage: PropTypes.string,
    maxLength: PropTypes.number,
    minLength: PropTypes.number,
    id: PropTypes.string,
  }
  state = {
    isPasswordInPlainText: false,
  }
  toggleIsPasswordInPlainText = () => {
    this.setState({
      isPasswordInPlainText: !this.state.isPasswordInPlainText,
    })
  }

  render = () => {
    const {isPasswordInPlainText} = this.state
    const {
      className,
      label,
      placeholder,
      value,
      onChange,
      onFocus,
      isValid,
      onBlurInput,
      showValidation,
      isMandatory,
      labelHelp,
      maxLength,
      invalidMessage,
      minLength,
      id,
    } = this.props

    return (
      <Input
        id={id}
        name={'password'}
        autoComplete={'password'}
        className={className}
        label={label}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        onFocus={onFocus}
        isValid={isValid}
        onBlurInput={onBlurInput}
        showValidation={showValidation}
        isMandatory={isMandatory}
        labelHelp={labelHelp}
        type={isPasswordInPlainText ? 'text' : 'password'}
        maxLength={maxLength}
        minLength={minLength}
        icon={isPasswordInPlainText ? EyeOff : Eye}
        onIconPress={this.toggleIsPasswordInPlainText}
        invalidMessage={invalidMessage}
      />
    )
  }
}
